/* ========================================
   SIZE + FABRIC TOGETHER (2026-10-02)
   On a product with a size dropdown AND the fabric card (the Wallace
   beds: Bed Size + Fabric), each fabric swatch is tied to ONE variant -
   the first size. Picking King and then a colour quietly put the QUEEN
   back in the cart, and changing the size reset the fabric and never
   moved the 360 viewer to that size.
   This block makes a swatch click use the variant for the size that is
   selected, and makes a size change keep the fabric and move the viewer.
   Products without a size dropdown are untouched.
   This file is included TWICE - run once only.
   ======================================== */

(function () {
  'use strict';

  if (window.cpSizeFabricFix) return;
  window.cpSizeFabricFix = true;

  function init() {
    var el = document.getElementById('cpProductJson');
    var selects = document.querySelectorAll('#cp-product-form select[data-option-position]');
    var swatches = document.querySelectorAll('.cp-fabric-card__swatch');
    if (!el || !selects.length || !swatches.length) return;

    var product;
    try { product = JSON.parse(el.textContent); } catch (e) { return; }
    var variants = (product && product.variants) || [];
    if (!variants.length) return;

    /* which option is the fabric: the one whose values match the swatch names */
    var firstName = swatches[0].getAttribute('data-fabric-name');
    var fabricPos = -1;
    for (var p = 0; p < (variants[0].options || []).length; p++) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options[p] === firstName) { fabricPos = p; break; }
      }
      if (fabricPos !== -1) break;
    }
    if (fabricPos === -1) return;

    function variantFor(fabric) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options[fabricPos] !== fabric) continue;
        var ok = true;
        for (var s = 0; s < selects.length; s++) {
          var pos = parseInt(selects[s].getAttribute('data-option-position'), 10) - 1;
          if (pos !== fabricPos && v.options[pos] !== selects[s].value) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function money(cents) {
      return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    /* before the swatch's own click handler runs, point it at the right size */
    document.addEventListener('click', function (e) {
      var sw = e.target.closest && e.target.closest('.cp-fabric-card__swatch');
      if (!sw) return;
      var v = variantFor(sw.getAttribute('data-fabric-name'));
      if (!v) return;
      sw.setAttribute('data-variant-id', String(v.id));
      sw.setAttribute('data-price', money(v.price));
      sw.setAttribute('data-price-cents', String(v.price));
      sw.setAttribute('data-available', v.available ? 'true' : 'false');
      if (v.compare_at_price && v.compare_at_price > v.price) {
        sw.setAttribute('data-compare-price', money(v.compare_at_price));
      } else {
        sw.removeAttribute('data-compare-price');
      }
    }, true);

    /* size changed: keep the fabric that is showing (re-select it for the new size) */
    function reselectActive() {
      var active = document.querySelector('.cp-fabric-card__swatch--active');
      if (active) active.click();
    }
    for (var s = 0; s < selects.length; s++) {
      selects[s].addEventListener('change', function () { setTimeout(reselectActive, 0); });
    }

    /* page opened on a size other than the first: line the viewer up with it */
    setTimeout(function () {
      var active = document.querySelector('.cp-fabric-card__swatch--active');
      var input = document.getElementById('cpVariantId');
      if (!active || !input) return;
      var v = variantFor(active.getAttribute('data-fabric-name'));
      if (v && String(v.id) !== active.getAttribute('data-variant-id')) reselectActive();
    }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ========================================
   360 VIEWER - BED DIMENSION THUMBNAIL, ONE PER SIZE (2026-10-02)
   Each Wallace bed page spins ONE studio record that holds two sizes
   (Queen + King, or Full + Twin). The dimension-shot fix further down
   draws a single set of measurements per record, so a King would show
   the Queen's numbers. On a bed page this block takes over: it picks the
   measurements for the size being shown (by the "-king" / "-twin" ending
   on the fabric folder) and writes the size name under the bed.
   Every other product is untouched - they still use the fix below.
   Must sit at the TOP of the file: it claims that fix's run-once flag
   first. This file is included TWICE - run once only.
   ======================================== */

(function () {
  'use strict';

  if (window.cpBedDimFix) return;
  window.cpBedDimFix = true;

  var el = document.getElementById('cpProductJson');
  if (!el) return;
  var title = '';
  try { title = JSON.parse(el.textContent).title || ''; } catch (e) { return; }
  if (!/\bbed\b/i.test(title) || /sleeper/i.test(title)) return;

  /* bed page: the general dimension-shot fix below stands down */
  window.cpDimensionShotFix = true;

  var UNIT = 'inches';
  var CAP_LEN = 8;
  var TEXT_PAD = 4;

  var shotsCache = {};
  var frameCache = {};
  var drawCache = {};
  var ourValue = null;

  function parseBaseUrl(url) {
    if (!url) return null;
    var i = url.indexOf('/renders/');
    if (i === -1) return null;
    var parts = url.substring(i + 9).split('/').filter(function (p) { return p; });
    if (!parts[0] || !parts[1]) return null;
    return { server: url.substring(0, i), sku: parts[0], material: parts[1] };
  }

  function getShots(info) {
    var key = info.server + '|' + info.sku;
    if (!shotsCache[key]) {
      shotsCache[key] = fetch(info.server + '/products/' + encodeURIComponent(info.sku))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var p = d && (d.product || d);
          return (p && p.dimension_shots) || [];
        })
        .catch(function () { return []; });
    }
    return shotsCache[key];
  }

  /* the shot whose material_suffix matches the folder ending, else the one without a suffix */
  function pickShot(shots, material) {
    var i, s;
    for (i = 0; i < shots.length; i++) {
      s = shots[i];
      if (s.material_suffix && material.slice(-(s.material_suffix.length + 1)) === '-' + s.material_suffix) return s;
    }
    for (i = 0; i < shots.length; i++) {
      if (!shots[i].material_suffix) return shots[i];
    }
    return shots[0] || null;
  }

  function getFrame002(info) {
    var key = info.server + '|' + info.sku + '|' + info.material;
    if (!frameCache[key]) {
      var dir = info.server + '/renders/' + encodeURIComponent(info.sku) + '/' + encodeURIComponent(info.material);
      frameCache[key] = fetch(dir + '/?list=true')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var files = (d && d.files) || [];
          for (var i = 0; i < files.length; i++) {
            if (/_002\.(jpe?g|png)$/i.test(files[i])) return dir + '/' + files[i];
          }
          return null;
        })
        .catch(function () { return null; });
    }
    return frameCache[key];
  }

  function drawLine(ctx, line) {
    var x1 = line.x1, y1 = line.y1, x2 = line.x2, y2 = line.y2;
    ctx.save();
    ctx.strokeStyle = line.color || '#000000';
    ctx.lineWidth = line.width || 2;
    ctx.lineCap = 'round';
    ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
    var perp = Math.atan2(y2 - y1, x2 - x1) + Math.PI / 2;
    var dx = Math.cos(perp) * CAP_LEN, dy = Math.sin(perp) * CAP_LEN;
    ctx.beginPath(); ctx.moveTo(x1 + dx, y1 + dy); ctx.lineTo(x1 - dx, y1 - dy); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(x2 + dx, y2 + dy); ctx.lineTo(x2 - dx, y2 - dy); ctx.stroke();
    if (line.value) {
      var midX = (x1 + x2) / 2, midY = (y1 + y2) / 2;
      var fontSize = line.fontSize || 14;
      var text = line.value + ' ' + UNIT;
      ctx.font = 'bold ' + fontSize + 'px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var w = ctx.measureText(text).width;
      ctx.fillStyle = 'rgba(255,255,255,0.85)';
      ctx.fillRect(midX - w / 2 - TEXT_PAD, midY - fontSize / 2 - TEXT_PAD, w + TEXT_PAD * 2, fontSize + TEXT_PAD * 2);
      ctx.fillStyle = line.color || '#000000';
      ctx.fillText(text, midX, midY);
    }
    ctx.restore();
  }

  function drawShot(info, frameUrl, shot) {
    var key = info.server + '|' + info.sku + '|' + info.material;
    if (!drawCache[key]) {
      drawCache[key] = new Promise(function (resolve, reject) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { resolve(img); };
        img.onerror = reject;
        img.src = frameUrl;
      }).then(function (img) {
        var canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        (shot.dimensions || []).forEach(function (line) { drawLine(ctx, line); });
        if (shot.size_label) {
          ctx.save();
          ctx.font = 'bold ' + (shot.size_label_font || 34) + 'px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillStyle = '#333333';
          ctx.fillText(shot.size_label, shot.size_label_x || canvas.width / 2, shot.size_label_y || canvas.height - 40);
          ctx.restore();
        }
        return new Promise(function (resolve) {
          canvas.toBlob(function (blob) {
            resolve(blob ? URL.createObjectURL(blob) : canvas.toDataURL('image/jpeg', 0.92));
          }, 'image/jpeg', 0.92);
        });
      }).catch(function () { return null; });
    }
    return drawCache[key];
  }

  function apply(viewer) {
    var info = parseBaseUrl(viewer.getAttribute('base-url'));
    if (!info) return;
    var key = info.sku + '|' + info.material;
    Promise.all([getShots(info), getFrame002(info)]).then(function (res) {
      var shot = pickShot(res[0], info.material), frameUrl = res[1];
      if (!shot || !frameUrl || !(shot.dimensions || []).length) return null;
      return drawShot(info, frameUrl, shot);
    }).then(function (url) {
      if (!url) return;
      var now = parseBaseUrl(viewer.getAttribute('base-url'));
      if (!now || now.sku + '|' + now.material !== key) return;
      var value = JSON.stringify([{ url: url, label: 'Dimensions' }]);
      if (viewer.getAttribute('dimension-shots') === value) return;
      ourValue = value;
      viewer.setAttribute('dimension-shots', value);
      if (typeof viewer.buildThumbnails === 'function') viewer.buildThumbnails();
    }).catch(function () {});
  }

  function init() {
    var viewer = document.getElementById('couch-potatoes-viewer');
    if (!viewer) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'dimension-shots' && viewer.getAttribute('dimension-shots') === ourValue) continue;
        apply(viewer);
        return;
      }
    }).observe(viewer, { attributes: true, attributeFilter: ['base-url', 'dimension-shots'] });
    apply(viewer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ========================================
   360 VIEWER - SLEEPER DIMENSION THUMBNAIL (2026-09-27)
   Sleepers spin their parent's model (Track Queen Sleeper spins
   TRACK-SOFA), so the dimension-shot fix further down would draw the
   parent's CLOSED measurements. On a Sleeper product that has its own
   "_dimensions" picture, show that picture instead and switch the
   drawing fix off for this page. Every other product is untouched.
   Must sit ABOVE the dimension-shot fix: it claims that fix's
   run-once flag first. This file is included TWICE - run once only.
   ======================================== */

(function () {
  'use strict';

  if (window.cpSleeperShotFix) return;
  window.cpSleeperShotFix = true;

  var el = document.getElementById('cpProductJson');
  if (!el) return;

  var shot = null;
  try {
    var p = JSON.parse(el.textContent);
    if (!/sleeper/i.test(p.title || '')) return;
    var imgs = p.images || [];
    for (var i = 0; i < imgs.length; i++) {
      if (/_dimensions/i.test(imgs[i])) { shot = imgs[i]; break; }
    }
  } catch (e) { return; }
  if (!shot) return;
  if (shot.indexOf('//') === 0) shot = 'https:' + shot;

  /* stop the dimension-shot fix below from drawing closed callouts here */
  window.cpDimensionShotFix = true;

  var value = JSON.stringify([{ url: shot, label: 'Dimensions' }]);

  function apply(viewer) {
    if (viewer.getAttribute('dimension-shots') === value) return;
    viewer.setAttribute('dimension-shots', value);
    if (typeof viewer.buildThumbnails === 'function') viewer.buildThumbnails();
  }

  function init() {
    var viewer = document.getElementById('couch-potatoes-viewer');
    if (!viewer) return;
    /* the viewer puts its own studio picture back after each load / fabric change */
    new MutationObserver(function () { apply(viewer); })
      .observe(viewer, { attributes: true, attributeFilter: ['base-url', 'dimension-shots'] });
    apply(viewer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ========================================
   COUCH POTATOES — Product Page JS
   Gallery, Fabric Card (metaobjects + fallback),
   Category Tabs, Product Tabs, Sticky Bar
   ======================================== */

(function () {
  'use strict';

  /* ── Shared metaobject lookup (populated by enrichSwatchesFromMeta) ── */
  var _moLookup = {};

  /* ── Enrich Swatch Grid with Metaobject JSON Data ── */
  /* Phase 1 (sync): Apply data-attributes for filtering/tabs from inline JSON */
  /* Phase 2 (async): Fetch image URLs from theme asset and set thumbnails */
  function enrichSwatchesFromMeta() {
    var metaEl = document.getElementById('cpSwatchMeta');
    if (!metaEl) return;

    var entries;
    try { entries = JSON.parse(metaEl.textContent); } catch (e) { return; }
    if (!entries || !entries.length) return;

    /* Build name→entry lookup */
    entries.forEach(function (e) {
      if (e.name) _moLookup[e.name] = e;
    });

    /* Phase 1: Synchronously set all data-attributes from metaobject data */
    var swatches = document.querySelectorAll('.cp-fabric-card__swatch');
    swatches.forEach(function (s) {
      var name = s.getAttribute('data-fabric-name');
      var mo = _moLookup[name];
      if (!mo) return;

      if (mo.material_type) {
        s.setAttribute('data-category', mo.material_type.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''));
        s.setAttribute('data-category-label', mo.material_type);
      }
      if (mo.color_family) {
        s.setAttribute('data-color-family', mo.color_family.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''));
      }
      if (mo.bestseller) s.setAttribute('data-best', 'true');
      if (mo.performance) s.setAttribute('data-performance', 'true');
      if (mo.pet_friendly) s.setAttribute('data-pet', 'true');
      if (mo.hex_color) s.setAttribute('data-color', mo.hex_color);
      if (mo.composition) s.setAttribute('data-composition', mo.composition);
      if (mo.cleaning_code) s.setAttribute('data-cleaning', mo.cleaning_code);
      if (mo.rub_score) s.setAttribute('data-rubs', mo.rub_score);
      if (mo.certifications) s.setAttribute('data-certs', mo.certifications);

      var tags = [];
      if (mo.performance) tags.push('Performance');
      if (mo.pet_friendly) tags.push('Pet-Friendly');
      s.setAttribute('data-tags', tags.join(','));

      /* Set hex color as initial fallback for swatch circle */
      var circle = s.querySelector('.cp-fabric-card__swatch-circle');
      if (circle && mo.hex_color && !circle.style.backgroundImage) {
        circle.style.cssText = "background:" + mo.hex_color + ";";
      }
    });

    /* Enrich active swatch preview */
    var activeSwatch = document.querySelector('.cp-fabric-card__swatch--active');
    if (activeSwatch) {
      var activeMo = _moLookup[activeSwatch.getAttribute('data-fabric-name')];
      if (activeMo) {
        var previewCategory = document.getElementById('cpPreviewCategory');
        var previewTags = document.getElementById('cpPreviewTags');
        if (previewCategory) previewCategory.textContent = activeMo.material_type || '';
        if (previewTags) {
          var tagHtml = '';
          if (activeMo.performance) tagHtml += '<span class="cp-fabric-card__tag">Performance</span>';
          if (activeMo.pet_friendly) tagHtml += '<span class="cp-fabric-card__tag">Pet-Friendly</span>';
          previewTags.innerHTML = tagHtml;
        }
      }
    }

    /* Phase 2: Apply swatch images from inline JSON snippet */
    var urlMapEl = document.getElementById('cpSwatchImageUrls');
    if (urlMapEl) {
      var imageUrlMap;
      try { imageUrlMap = JSON.parse(urlMapEl.textContent); } catch (e) { /* ignore */ }
      if (imageUrlMap) applySwatchImages(imageUrlMap);
    }
  }

  /* Apply swatch thumbnail images from the URL mapping. Returns count. */
  function applySwatchImages(imageUrlMap) {
    if (!imageUrlMap) return 0;
    var applied = 0;
    var swatches = document.querySelectorAll('.cp-fabric-card__swatch');
    swatches.forEach(function (s) {
      var name = s.getAttribute('data-fabric-name');
      var url = imageUrlMap[name];
      if (!url) return;
      s.setAttribute('data-swatch-url', url);
      s.setAttribute('data-swatch-lg', url);
      var circle = s.querySelector('.cp-fabric-card__swatch-circle');
      if (circle) {
        /* Use an actual <img> tag inside the circle for maximum reliability */
        circle.innerHTML = '';
        circle.style.cssText = '';
        var img = document.createElement('img');
        img.src = url;
        img.alt = name;
        img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
        circle.appendChild(img);
        applied++;
      }
    });

    /* Update active swatch preview if it has an image */
    var activeSwatch = document.querySelector('.cp-fabric-card__swatch--active');
    if (activeSwatch) {
      var activeUrl = imageUrlMap[activeSwatch.getAttribute('data-fabric-name')];
      setPreviewSwatchImage(activeUrl);
    }

    return applied;
  }

  /* ── Set preview swatch image (shared by init + click) ── */
  function setPreviewSwatchImage(url) {
    var previewSwatch = document.getElementById('cpPreviewSwatch');
    if (!previewSwatch) return;
    if (url) {
      previewSwatch.innerHTML = '<img src="' + url + '" alt="" style="width:100%;height:100%;object-fit:cover;display:block;border-radius:6px;">';
      previewSwatch.style.cssText = '';
    } else {
      previewSwatch.innerHTML = '';
    }
  }

  /* ── Gallery Thumbnail Switching ── */
  function initGallery() {
    var mainImage = document.getElementById('cpMainImage');
    var thumbs = document.querySelectorAll('.cp-gallery__thumb');
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = this.getAttribute('data-image-url');
        if (url) {
          mainImage.src = url;
          thumbs.forEach(function (t) { t.classList.remove('cp-gallery__thumb--active'); });
          this.classList.add('cp-gallery__thumb--active');
        }
      });
    });
  }

  /* ── Fabric Card: Combined Tab + Color Filtering ── */
  var activeCat = 'all';
  var activeColor = 'all';

  function applyFabricFilters() {
    var swatches = document.querySelectorAll('.cp-fabric-card__swatch');
    var visibleCount = 0;
    swatches.forEach(function (s) {
      var showCat = true;
      var showColor = true;

      /* Category / tab filter */
      if (activeCat !== 'all') {
        if (activeCat === 'best-sellers') {
          showCat = s.getAttribute('data-best') === 'true';
        } else if (activeCat === 'performance') {
          showCat = s.getAttribute('data-performance') === 'true';
        } else if (activeCat === 'pet-friendly') {
          showCat = s.getAttribute('data-pet') === 'true';
        } else {
          showCat = s.getAttribute('data-category') === activeCat;
        }
      }

      /* Color family filter */
      if (activeColor !== 'all') {
        showColor = s.getAttribute('data-color-family') === activeColor;
      }

      s.style.display = (showCat && showColor) ? '' : 'none';
      if (showCat && showColor) visibleCount++;
    });

    /* Update count in footer */
    var countEl = document.querySelector('.cp-fabric-card__count');
    if (countEl) {
      var fabricCard = document.getElementById('cpFabricCard');
      var optName = fabricCard ? (fabricCard.getAttribute('data-option-name') || 'fabric') : 'fabric';
      var label = optName.toLowerCase() === 'leather' ? 'leathers' : 'fabrics';
      countEl.textContent = visibleCount + ' ' + label + ' available';
    }
  }

  function initFabricTabs() {
    var tabs = document.querySelectorAll('.cp-fabric-card__tab');
    var colorDots = document.querySelectorAll('.cp-fabric-card__color-dot');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activeCat = this.getAttribute('data-cat');
        tabs.forEach(function (t) { t.classList.remove('cp-fabric-card__tab--active'); });
        this.classList.add('cp-fabric-card__tab--active');
        applyFabricFilters();
      });
    });

    colorDots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        activeColor = this.getAttribute('data-color-family');
        colorDots.forEach(function (d) { d.classList.remove('cp-fabric-card__color-dot--active'); });
        this.classList.add('cp-fabric-card__color-dot--active');
        applyFabricFilters();
      });
    });

    /* Initialize: click first tab to filter */
    if (tabs[0]) tabs[0].click();
  }

  /* ── Fabric Card: Swatch Selection ── */
  function initFabricCard() {
    var fabricSwatches = document.querySelectorAll('.cp-fabric-card__swatch');
    if (!fabricSwatches.length) return;

    var previewSwatch = document.getElementById('cpPreviewSwatch');
    var previewName = document.getElementById('cpPreviewName');
    var previewCategory = document.getElementById('cpPreviewCategory');
    var previewTags = document.getElementById('cpPreviewTags');
    var variantIdInput = document.getElementById('cpVariantId');
    var addToCartBtn = document.getElementById('cpAddToCartBtn');
    var productPrice = document.getElementById('cpProductPrice');
    var comparePrice = document.getElementById('cpComparePrice');
    var affirmPrice = document.getElementById('cpAffirmPrice');
    var stickyPrice = document.getElementById('cpStickyPrice');
    var mainImage = document.getElementById('cpMainImage');
    var thumbs = document.querySelectorAll('.cp-gallery__thumb');

    fabricSwatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var name = this.getAttribute('data-fabric-name');
        var variantId = this.getAttribute('data-variant-id');
        var imageUrl = this.getAttribute('data-image-url');
        var swatchUrl = this.getAttribute('data-swatch-url');
        var color = this.getAttribute('data-color');
        var categoryLabel = this.getAttribute('data-category-label');
        var tags = this.getAttribute('data-tags');
        var price = this.getAttribute('data-price');
        var priceCents = parseInt(this.getAttribute('data-price-cents'), 10);
        var cmpPrice = this.getAttribute('data-compare-price');
        var available = this.getAttribute('data-available') !== 'false';

        /* Update active state */
        fabricSwatches.forEach(function (s) { s.classList.remove('cp-fabric-card__swatch--active'); });
        this.classList.add('cp-fabric-card__swatch--active');

        /* Update preview swatch image/color */
        setPreviewSwatchImage(swatchUrl);
        if (!swatchUrl && previewSwatch) {
          if (color) {
            previewSwatch.innerHTML = '';
            previewSwatch.style.cssText = "background:" + color + ";";
          }
        }

        /* Update preview name */
        if (previewName) previewName.textContent = name || '';

        /* Update preview category */
        if (previewCategory) previewCategory.textContent = categoryLabel || '';

        /* Update preview tags */
        if (previewTags) {
          if (tags && tags.length > 0) {
            previewTags.innerHTML = tags.split(',').map(function (t) {
              return '<span class="cp-fabric-card__tag">' + t.trim() + '</span>';
            }).join('');
          } else {
            previewTags.innerHTML = '';
          }
        }

        /* Update main image */
        if (imageUrl && mainImage) {
          mainImage.src = imageUrl;
          thumbs.forEach(function (t) { t.classList.remove('cp-gallery__thumb--active'); });
        }

        /* Update variant ID */
        if (variantIdInput && variantId) {
          variantIdInput.value = variantId;
        }

        /* Update 360 viewer if present */
        if (window.couchPotatoesConfig && variantId) {
          var materialFolder = window.couchPotatoesConfig.variants[variantId];
          var viewer = document.getElementById('couch-potatoes-viewer');
          if (viewer && materialFolder) {
            viewer.setAttribute('base-url', window.couchPotatoesConfig.baseUrl + '/' + materialFolder);
          }
        }

        /* Update prices */
        if (price) {
          if (productPrice) productPrice.textContent = price;
          if (stickyPrice) stickyPrice.textContent = price;
        }

        if (comparePrice) {
          if (cmpPrice) {
            comparePrice.textContent = cmpPrice;
            comparePrice.style.display = '';
          } else {
            comparePrice.style.display = 'none';
          }
        }

        /* Update Affirm monthly price */
        if (affirmPrice && priceCents) {
          var monthly = Math.round(priceCents / 12);
          var dollars = (monthly / 100).toFixed(2);
          affirmPrice.textContent = '$' + dollars;
        }

        /* Update add to cart button */
        if (addToCartBtn) {
          if (available && price) {
            addToCartBtn.disabled = false;
            addToCartBtn.innerHTML = 'Add to Cart &mdash; <span id="cpCartBtnPrice">' + price + '</span>';
          } else if (!available) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'Sold Out';
          }
        }

        /* Update protection plan prices */
        if (priceCents) {
          currentPriceCents = priceCents;
          updatePlanPrices();
        }

        /* Update URL with variant */
        if (variantId && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ── Option Select Variant Switching (e.g. Bedding size) ── */
  function initOptionSelects() {
    var selects = document.querySelectorAll('#cp-product-form select[data-option-position]');
    if (!selects.length) return;

    var productDataEl = document.getElementById('cpProductJson');
    if (!productDataEl) return;
    var productData;
    try { productData = JSON.parse(productDataEl.textContent); } catch (e) { return; }
    if (!productData || !productData.variants) return;

    var variantInput = document.getElementById('cpVariantId');
    var productPrice = document.getElementById('cpProductPrice');
    var comparePrice = document.getElementById('cpComparePrice');
    var affirmPrice = document.getElementById('cpAffirmPrice');
    var stickyPrice = document.getElementById('cpStickyPrice');
    var addToCartBtn = document.getElementById('cpAddToCartBtn');

    function resolveVariant() {
      /* Build selected options from all selects */
      var selectedOptions = [];
      selects.forEach(function (sel) {
        var pos = parseInt(sel.getAttribute('data-option-position'), 10) - 1;
        selectedOptions[pos] = sel.value;
      });

      /* Find matching variant */
      var matched = null;
      for (var i = 0; i < productData.variants.length; i++) {
        var v = productData.variants[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (selectedOptions[j] && v.options[j] !== selectedOptions[j]) {
            match = false;
            break;
          }
        }
        if (match) { matched = v; break; }
      }

      if (!matched) return;

      /* Update variant input */
      if (variantInput) variantInput.value = matched.id;

      /* Update prices */
      var formatted = formatMoney(matched.price);
      if (productPrice) productPrice.textContent = formatted;
      if (stickyPrice) stickyPrice.textContent = formatted;

      if (affirmPrice) {
        var monthly = Math.round(matched.price / 12);
        affirmPrice.textContent = '$' + (monthly / 100).toFixed(2);
      }

      if (comparePrice) {
        if (matched.compare_at_price && matched.compare_at_price > matched.price) {
          comparePrice.textContent = formatMoney(matched.compare_at_price);
          comparePrice.style.display = '';
        } else {
          comparePrice.style.display = 'none';
        }
      }

      /* Update add to cart button */
      if (addToCartBtn) {
        if (matched.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.innerHTML = 'Add to Cart &mdash; <span id="cpCartBtnPrice">' + formatted + '</span>';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Sold Out';
        }
      }

      /* Update protection plan */
      currentPriceCents = matched.price;
      updatePlanPrices();

      /* Update URL */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', matched.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', resolveVariant);
    });
  }

  /* ── Product Tabs ── */
  function initTabs() {
    var tabBtns = document.querySelectorAll('.cp-product-tabs__btn');
    var tabContents = document.querySelectorAll('.cp-tab-content');
    if (!tabBtns.length) return;

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = this.getAttribute('data-tab-target');

        tabBtns.forEach(function (b) { b.classList.remove('cp-product-tabs__btn--active'); });
        tabContents.forEach(function (c) { c.classList.remove('cp-tab-content--active'); });

        this.classList.add('cp-product-tabs__btn--active');
        var targetEl = document.getElementById(target);
        if (targetEl) targetEl.classList.add('cp-tab-content--active');
      });
    });
  }

  /* ── Sticky Bottom Bar ── */
  function initStickyBar() {
    var stickyBar = document.getElementById('cpStickyBar');
    var addToCartArea = document.getElementById('cpAddToCartBtn');
    var stickyAddBtn = document.getElementById('cpStickyAddBtn');

    if (stickyBar && addToCartArea) {
      window.addEventListener('scroll', function () {
        var rect = addToCartArea.getBoundingClientRect();
        if (rect.bottom < 0) {
          stickyBar.classList.add('cp-sticky-bar--visible');
        } else {
          stickyBar.classList.remove('cp-sticky-bar--visible');
        }
      }, { passive: true });
    }

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        var form = document.getElementById('cp-product-form');
        if (form) {
          if (form.requestSubmit) {
            form.requestSubmit();
          } else {
            form.submit();
          }
        }
      });
    }
  }

  /* ── Swatch Hover Tooltip ── */
  function initSwatchTooltip() {
    var tooltip = document.getElementById('cpSwatchTooltip');
    var grid = document.getElementById('cpFabricGrid');
    if (!tooltip || !grid) return;

    var tipImg = document.getElementById('cpTipImg');
    var tipName = document.getElementById('cpTipName');
    var tipType = document.getElementById('cpTipType');
    var tipSpecs = document.getElementById('cpTipSpecs');
    var tipBadges = document.getElementById('cpTipBadges');
    var hideTimer = null;

    grid.addEventListener('mouseover', function (e) {
      var swatch = e.target.closest('.cp-fabric-card__swatch');
      if (!swatch) return;

      var name = swatch.getAttribute('data-fabric-name');
      var catLabel = swatch.getAttribute('data-category-label');
      var swatchLg = swatch.getAttribute('data-swatch-lg');
      var swatchUrl = swatch.getAttribute('data-swatch-url');
      var color = swatch.getAttribute('data-color');
      var composition = swatch.getAttribute('data-composition');
      var cleaning = swatch.getAttribute('data-cleaning');
      var rubs = swatch.getAttribute('data-rubs');
      var certs = swatch.getAttribute('data-certs');
      var pet = swatch.getAttribute('data-pet') === 'true';
      var perf = swatch.getAttribute('data-performance') === 'true';

      /* Only show tooltip if there's metaobject data */
      if (!catLabel && !composition && !cleaning) return;

      clearTimeout(hideTimer);

      /* Image — use <img> tag for reliable rendering */
      if (tipImg) {
        var imgUrl = swatchLg || swatchUrl;
        if (imgUrl) {
          tipImg.innerHTML = '<img src="' + imgUrl + '" alt="' + (name || '') + '" style="width:100%;height:100%;object-fit:cover;display:block;">';
          tipImg.style.backgroundColor = '';
          tipImg.style.display = '';
        } else if (color) {
          tipImg.innerHTML = '';
          tipImg.style.backgroundColor = color;
          tipImg.style.display = '';
        } else {
          tipImg.innerHTML = '';
          tipImg.style.display = 'none';
        }
      }

      /* Name & type */
      if (tipName) tipName.textContent = name || '';
      if (tipType) tipType.textContent = catLabel || '';

      /* Specs */
      if (tipSpecs) {
        var specsHtml = '';
        if (composition) specsHtml += '<span><strong>Composition:</strong> ' + composition + '</span>';
        if (cleaning) specsHtml += '<span><strong>Cleaning Code:</strong> ' + cleaning + '</span>';
        if (rubs) specsHtml += '<span><strong>Durability:</strong> ' + rubs + ' rubs</span>';
        tipSpecs.innerHTML = specsHtml;
      }

      /* Badges */
      if (tipBadges) {
        var badgesHtml = '';
        if (pet) badgesHtml += '<span class="cp-swatch-tooltip__badge">Pet-Friendly</span>';
        if (perf) badgesHtml += '<span class="cp-swatch-tooltip__badge cp-swatch-tooltip__badge--perf">Performance</span>';
        if (certs) badgesHtml += '<span class="cp-swatch-tooltip__badge cp-swatch-tooltip__badge--cert">' + certs + '</span>';
        tipBadges.innerHTML = badgesHtml;
      }

      /* Position tooltip above the swatch using fixed viewport coordinates */
      var swatchRect = swatch.getBoundingClientRect();
      var tipWidth = 260;

      /* Center horizontally on swatch, clamp to viewport */
      var left = swatchRect.left + (swatchRect.width / 2) - (tipWidth / 2);
      if (left < 8) left = 8;
      if (left + tipWidth > window.innerWidth - 8) left = window.innerWidth - 8 - tipWidth;

      /* Position above swatch with gap */
      var top = swatchRect.top - 10;

      tooltip.style.left = left + 'px';
      tooltip.style.top = top + 'px';
      tooltip.style.bottom = 'auto';
      tooltip.style.transform = 'translateY(-100%)';
      tooltip.style.display = '';
      tooltip.style.opacity = '1';

      /* Update arrow position */
      var arrowEl = tooltip.querySelector('.cp-swatch-tooltip__arrow');
      if (arrowEl) {
        var arrowLeft = (swatchRect.left + swatchRect.width / 2) - left;
        arrowLeft = Math.max(12, Math.min(arrowLeft, tipWidth - 12));
        arrowEl.style.left = arrowLeft + 'px';
      }
    });

    grid.addEventListener('mouseout', function (e) {
      var swatch = e.target.closest('.cp-fabric-card__swatch');
      if (!swatch) return;
      var related = e.relatedTarget;
      if (related && (related.closest('.cp-fabric-card__swatch') || related.closest('.cp-swatch-tooltip'))) return;
      hideTimer = setTimeout(function () {
        tooltip.style.opacity = '0';
        setTimeout(function () { tooltip.style.display = 'none'; }, 150);
      }, 100);
    });
  }

  /* ── Protection Plan ── */
  var currentPriceCents = 0;
  var planVariants = [];

  function initProtectionPlan() {
    var protectionEl = document.getElementById('cpProtection');
    if (!protectionEl) return;

    /* Load plan product variants */
    var planDataEl = document.getElementById('cpPlanVariants');
    if (planDataEl) {
      try { planVariants = JSON.parse(planDataEl.textContent); } catch (e) { planVariants = []; }
    }

    /* Radio selection UI */
    var options = protectionEl.querySelectorAll('.cp-protection__option');
    var radios = protectionEl.querySelectorAll('input[name="protection_plan"]');

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        options.forEach(function (opt) { opt.classList.remove('cp-protection__option--active'); });
        this.closest('.cp-protection__option').classList.add('cp-protection__option--active');
      });
    });

    /* Set initial prices from current variant */
    var productData = document.getElementById('cpProductJson');
    if (productData) {
      try {
        var product = JSON.parse(productData.textContent);
        /* Use selected variant from URL or first available */
        var urlParams = new URLSearchParams(window.location.search);
        var selectedId = urlParams.get('variant');
        var variant = null;
        if (selectedId && product.variants) {
          for (var i = 0; i < product.variants.length; i++) {
            if (String(product.variants[i].id) === selectedId) { variant = product.variants[i]; break; }
          }
        }
        if (!variant) variant = product.variants && product.variants[0];
        if (variant) {
          currentPriceCents = variant.price;
          updatePlanPrices();
        }
      } catch (e) {}
    }
  }

  function updatePlanPrices() {
    var plan4yr = document.getElementById('cpPlan4yr');
    var planPet = document.getElementById('cpPlanPet');
    if (plan4yr) {
      var target4 = Math.round(currentPriceCents * 0.17);
      var variant4 = findClosestPlanVariant(target4);
      plan4yr.textContent = variant4 ? formatMoney(variant4.price) : formatMoney(target4);
    }
    if (planPet) {
      var targetPet = Math.round(currentPriceCents * 0.20);
      var variantPet = findClosestPlanVariant(targetPet);
      planPet.textContent = variantPet ? formatMoney(variantPet.price) : formatMoney(targetPet);
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function findClosestPlanVariant(targetCents) {
    if (!planVariants.length) return null;
    var closest = planVariants[0];
    var closestDiff = Math.abs(planVariants[0].price - targetCents);
    for (var i = 1; i < planVariants.length; i++) {
      var diff = Math.abs(planVariants[i].price - targetCents);
      if (diff < closestDiff) {
        closest = planVariants[i];
        closestDiff = diff;
      }
    }
    return closest;
  }

  function getSelectedPlanVariantId() {
    var selected = document.querySelector('input[name="protection_plan"]:checked');
    if (!selected || selected.value === 'none') return null;
    var rate = parseFloat(selected.getAttribute('data-rate'));
    if (!rate || !currentPriceCents) return null;
    var planPrice = Math.round(currentPriceCents * rate);
    var variant = findClosestPlanVariant(planPrice);
    return variant ? variant.id : null;
  }

  /* ── Add to Cart AJAX ── */
  function initAddToCart() {
    var productForm = document.getElementById('cp-product-form');
    if (!productForm) return;

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = this.querySelector('[type="submit"]');
      if (!submitBtn || submitBtn.disabled) return;

      var originalHTML = submitBtn.innerHTML;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';

      var variantId = document.getElementById('cpVariantId').value;
      var items = [{ id: parseInt(variantId, 10), quantity: 1 }];

      /* Add protection plan if selected */
      var planVariantId = getSelectedPlanVariantId();
      if (planVariantId) {
        items.push({
          id: planVariantId,
          quantity: 1,
          properties: { '_plan_for': variantId }
        });
      }

      var cartDrawer = document.querySelector('cart-drawer');
      var payload = { items: items };
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        payload.sections = 'cart-drawer';
        payload.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data && data.status && data.description) throw new Error(data.description);

          submitBtn.innerHTML = 'Added! &#10003;';
          setTimeout(function () {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalHTML;
          }, 2000);

          /* Show the cart drawer with the new item */
          if (cartDrawer && data && data.sections && data.sections['cart-drawer']) {
            try {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(data);
            } catch (e) {
              console.error('Cart drawer render error:', e);
            }
          }

          /* Update the header cart count */
          if (typeof window.cpRefreshCartCount === 'function') {
            window.cpRefreshCartCount();
          } else {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function (el) {
                  el.textContent = cart.item_count;
                });
              });
          }
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
          submitBtn.textContent = (err && err.message) ? err.message : 'Couldn\'t add to cart. Please try again.';
          setTimeout(function () {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalHTML;
          }, 3000);
        });
    });
  }

  /* ── Initialize Everything ── */
  function init() {
    initGallery();
    enrichSwatchesFromMeta();
    initFabricTabs();
    initFabricCard();
    initSwatchTooltip();
    initProtectionPlan();
    initOptionSelects();
    initTabs();
    initStickyBar();
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ========================================
   360 VIEWER â€” DIMENSION SHOT FIX
   The viewer builds its own thumbnail strip and fetches the dimension
   shot straight from the studio. That shot is the plain frame 002 of a
   single fixed fabric, with the measurements stored beside it as
   coordinates and never drawn. So every colour showed the same picture
   and none of them showed the numbers.

   This draws the stored measurements onto the SELECTED fabric's own
   frame 002 in the browser, and hands the result to the viewer.
   Mirrors the studio's own drawDimLine() so the result matches the
   dimension shot at gallery position 2.
   ======================================== */

(function () {
  'use strict';

  /* This file is included TWICE on a product page. Two copies of the code
     below would each draw their own picture and then fight over the
     viewer's dimension-shots attribute forever, locking the page up.
     Run once only. */
  if (window.cpDimensionShotFix) return;
  window.cpDimensionShotFix = true;

  var UNIT = 'inches';
  var CAP_LEN = 8;
  var TEXT_PAD = 4;

  var dimsCache = {};   /* server|sku          -> Promise<array>  */
  var frameCache = {};  /* server|sku|material -> Promise<string> */
  var shotCache = {};   /* server|sku|material -> Promise<string> */
  var ourValue = null;  /* the dimension-shots value we set ourselves */

  function parseBaseUrl(url) {
    if (!url) return null;
    var i = url.indexOf('/renders/');
    if (i === -1) return null;
    var parts = url.substring(i + 9).split('/').filter(function (p) { return p; });
    if (!parts[0] || !parts[1]) return null;
    return { server: url.substring(0, i), sku: parts[0], material: parts[1] };
  }

  function getDimensions(info) {
    var key = info.server + '|' + info.sku;
    if (!dimsCache[key]) {
      dimsCache[key] = fetch(info.server + '/products/' + encodeURIComponent(info.sku))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var p = d && (d.product || d);
          var shots = p && p.dimension_shots;
          if (!shots || !shots.length) return [];
          return shots[0].dimensions || [];
        })
        .catch(function () { return []; });
    }
    return dimsCache[key];
  }

  function getFrame002(info) {
    var key = info.server + '|' + info.sku + '|' + info.material;
    if (!frameCache[key]) {
      var dir = info.server + '/renders/' + encodeURIComponent(info.sku) + '/' + encodeURIComponent(info.material);
      frameCache[key] = fetch(dir + '/?list=true')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var files = (d && d.files) || [];
          for (var i = 0; i < files.length; i++) {
            if (/_002\.(jpe?g|png)$/i.test(files[i])) return dir + '/' + files[i];
          }
          return null;
        })
        .catch(function () { return null; });
    }
    return frameCache[key];
  }

  /* Same geometry and styling as the studio's drawDimLine() at scale 1 */
  function drawDimensionLine(ctx, line) {
    var x1 = line.x1, y1 = line.y1, x2 = line.x2, y2 = line.y2;

    ctx.save();
    ctx.strokeStyle = line.color || '#000000';
    ctx.lineWidth = line.width || 2;
    ctx.lineCap = 'round';

    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();

    var perp = Math.atan2(y2 - y1, x2 - x1) + Math.PI / 2;
    var dx = Math.cos(perp) * CAP_LEN;
    var dy = Math.sin(perp) * CAP_LEN;

    ctx.beginPath();
    ctx.moveTo(x1 + dx, y1 + dy);
    ctx.lineTo(x1 - dx, y1 - dy);
    ctx.stroke();

    ctx.beginPath();
    ctx.moveTo(x2 + dx, y2 + dy);
    ctx.lineTo(x2 - dx, y2 - dy);
    ctx.stroke();

    if (line.value) {
      var midX = (x1 + x2) / 2;
      var midY = (y1 + y2) / 2;
      var fontSize = line.fontSize || 14;
      var text = line.value + ' ' + UNIT;

      ctx.font = 'bold ' + fontSize + 'px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      var w = ctx.measureText(text).width;
      ctx.fillStyle = 'rgba(255,255,255,0.85)';
      ctx.fillRect(midX - w / 2 - TEXT_PAD, midY - fontSize / 2 - TEXT_PAD,
                   w + TEXT_PAD * 2, fontSize + TEXT_PAD * 2);

      ctx.fillStyle = line.color || '#000000';
      ctx.fillText(text, midX, midY);
    }

    ctx.restore();
  }

  function buildDimensionShot(info, frameUrl, dims) {
    var key = info.server + '|' + info.sku + '|' + info.material;
    if (!shotCache[key]) {
      shotCache[key] = new Promise(function (resolve, reject) {
        var img = new Image();
        img.crossOrigin = 'anonymous';   /* studio sends access-control-allow-origin: * */
        img.onload = function () { resolve(img); };
        img.onerror = reject;
        img.src = frameUrl;
      }).then(function (img) {
        var canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        dims.forEach(function (line) { drawDimensionLine(ctx, line); });
        return new Promise(function (resolve) {
          canvas.toBlob(function (blob) {
            resolve(blob ? URL.createObjectURL(blob) : canvas.toDataURL('image/jpeg', 0.92));
          }, 'image/jpeg', 0.92);
        });
      }).catch(function () { return null; });
    }
    return shotCache[key];
  }

  function applyDimensionShot(viewer) {
    var info = parseBaseUrl(viewer.getAttribute('base-url'));
    if (!info) return;
    var key = info.sku + '|' + info.material;

    Promise.all([getDimensions(info), getFrame002(info)]).then(function (res) {
      var dims = res[0], frameUrl = res[1];
      if (!frameUrl || !dims.length) return null;
      return buildDimensionShot(info, frameUrl, dims);
    }).then(function (url) {
      if (!url) return;
      /* the shopper may have picked another fabric while we were working */
      var now = parseBaseUrl(viewer.getAttribute('base-url'));
      if (!now || now.sku + '|' + now.material !== key) return;

      var value = JSON.stringify([{ url: url, label: 'Dimensions' }]);
      if (viewer.getAttribute('dimension-shots') === value) return;
      ourValue = value;
      viewer.setAttribute('dimension-shots', value);
      if (typeof viewer.buildThumbnails === 'function') viewer.buildThumbnails();
    }).catch(function () { /* leave the viewer's own thumbnail in place */ });
  }

  function initDimensionShotFix() {
    var viewer = document.getElementById('couch-potatoes-viewer');
    if (!viewer) return;

    /* The viewer sets dimension-shots itself once it has fetched the product,
       which would put the wrong-fabric picture back â€” redraw whenever either
       the fabric or that attribute changes. */
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var name = mutations[i].attributeName;
        if (name === 'dimension-shots' && viewer.getAttribute('dimension-shots') === ourValue) continue;
        applyDimensionShot(viewer);
        return;
      }
    }).observe(viewer, { attributes: true, attributeFilter: ['base-url', 'dimension-shots'] });

    applyDimensionShot(viewer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDimensionShotFix);
  } else {
    initDimensionShotFix();
  }

})();
